/**
 * Keys that are not stored per environment type
 */
export enum RawLocalStorageKeys {
    userProfileCurrency = 'userProfile.currency',
    userProfileLanguage= "userProfile.language",
    testModeEnabled = "userProfile.testModeEnabled",
    envConfigsPreferredApiOrigin = "envConfigs.preferredApiOrigin",
    forceHybridLayout = "application.forceHybridLayout",
    forcePortalType = "application.forcePortalType"
}

